import React from 'react'

const CircleHalfFilled = () => {
  return (
<svg fill="#000000" width="15px" height="15px" viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg">
    <path d="M962 0c530.193 0 960 429.807 960 960s-429.807 960-960 960S2 1490.193 2 960 431.807 0 962 0Zm0 106.667c-453.37 0-824.16 353.558-851.693 799.994h1703.386C1786.16 460.225 1415.37 106.667 962 106.667Z"/>
</svg>
  )
}
export default CircleHalfFilled